import { useEffect, useMemo, useRef, useState } from 'react';
import {
  DrawerTooltipContainer,
  DrawerTooltipContainerRef,
} from 'src/v2/commonComponents/DrawerTooltipContainer';
import { Button } from 'src/v2/commonComponents/Button';
import { VersioningToggle } from '../VersioningToggle';
import { useEditorControl, useGetEditorThread } from 'src/hooks';
import styles from './VersioningControl.module.scss';

const anchorId = 'versioning-control-tooltip-anchor';

export const VersioningControl = () => {
  const drawerRef = useRef<DrawerTooltipContainerRef>(null);

  const { editorThread } = useGetEditorThread();
  const { artifact } = editorThread ?? {};
  const versionList = useMemo(() => artifact?.contents || [], [artifact]);

  const { onInsertArtifactToEditor } = useEditorControl();

  const [selectedVersionIndex, setSelectedVersionIndex] = useState<number>(1);

  useEffect(() => {
    setSelectedVersionIndex(versionList.length);
  }, [versionList]);

  const handleClick = (index: number) => () => {
    drawerRef.current?.onVisibilityToggle();
    setSelectedVersionIndex(index);

    const currentArtifact = versionList.find((item) => item.index === index);
    onInsertArtifactToEditor(currentArtifact);
  };

  return (
    <DrawerTooltipContainer
      ref={drawerRef}
      id={anchorId}
      place="bottom-end"
      offset={8}
      onlyTooltip
      classNameTooltip={styles.tooltip}
      ToggleButton={VersioningToggle}
      disabledToggle={versionList.length <= 1}
    >
      <div className={styles.container}>
        {versionList.map(({ index }) => {
          const isLatestElement = index === versionList.length;
          const isSelected = selectedVersionIndex === index;

          return (
            <Button
              className={styles.button}
              color={isSelected ? 'tertiary' : 'transparent'}
              onClick={handleClick(index ?? 1)}
              key={index}
            >
              <span>
                {isLatestElement ? 'Latest version' : `Version ${index ?? 1}`}
              </span>
            </Button>
          );
        })}
      </div>
    </DrawerTooltipContainer>
  );
};
